export default __webpack_public_path__ + "static/media/Me.9e2ca9c6.jpg";